/* eslint-disable header/header */
export var name = "msal";
export var version = "1.4.15";
//# sourceMappingURL=packageMetadata.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/msal/lib-es6/packageMetadata.js
// module id = 111
// module chunks = 0